var exports = {
  "i": "AltTextBadge.module__wrapper___eG13Wk",
  "x": "AltTextBadge.module__button___eG13Wk",
};

module.exports = exports;
